import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import DiscussionHero from 'flarum/forum/components/DiscussionHero';
import Link from 'flarum/common/components/Link';
import MarketsHubPage from './components/MarketsHubPage';
import MarketsPage from './components/MarketsPage';
import StockPage from './components/StockPage';
import CommoditiesPage from './components/CommoditiesPage';
app.initializers.add('voucha-markets', () => {
  // every market in one place, each leading to its own page
  app.routes['voucha.markets'] = {
    path: '/markets',
    component: MarketsHubPage
  };
  // the NGX (before /markets/:symbol, so it isn't read as a company)
  app.routes['voucha.markets.ngx'] = {
    path: '/markets/ngx',
    component: MarketsPage
  };
  // one page per listed company: /markets/mtnn
  app.routes['voucha.markets.stock'] = {
    path: '/markets/:symbol',
    component: StockPage
  };
  // world commodity prices
  app.routes['voucha.commodities'] = {
    path: '/commodities',
    component: CommoditiesPage
  };

  // A company's comment thread links back to its company page, under the discussion's title
  extend(DiscussionHero.prototype, 'items', function (items) {
    const symbol = this.attrs.discussion && this.attrs.discussion.attribute('vouchaStockSymbol');
    if (!symbol) return;
    items.add('voucha-stock', m(Link, {
      className: 'VouchaMk-heroLink',
      href: app.route('voucha.markets.stock', {
        symbol: String(symbol).toLowerCase()
      })
    }, [m('i.fas.fa-chart-line', {
      'aria-hidden': 'true'
    }), ' ' + symbol + ' on Markets: price, chart and figures →']), -10);
  });
});